<template>
  <div>
    <!-- Mobile Top Bar with Phone Number -->
    <div class="mobile-top-bar d-lg-none">
      <b-container fluid class="py-2 bg-light text-center">
        <a href="tel:6042456680" class="mobile-phone" aria-label="Call us at 604-245-6680">
          📞 604-245-6680
        </a>
      </b-container>
    </div>

    <!-- Navbar -->
    <b-navbar
      v-b-scrollspy:nav-scroller
      type="light"
      class="navbar-light theme-nav fixed-top"
      toggleable="lg"
      fixed="top"
    >
      <div class="container linkSelected">
        <b-navbar-toggle target="nav_collapse" />
        <b-navbar-brand
          class="navbar-brand"
          :to="{ name: 'Home' }"
        >
          <div class="logoback">
            <img
              src="../assets/images/logo.png"
              alt="logo"
            />
          </div>
        </b-navbar-brand>
        <b-collapse
          id="nav_collapse"
          class="default-nav"
          is-nav
        >
          <b-navbar-nav
            id="mymenu"
            class="navbar-nav ml-auto"
          >
            <b-nav-item :to="{ name: 'Home', hash: '#home' }" class="navHome">
              Home
            </b-nav-item>
            <b-nav-item :to="{ name: 'AboutUs' }">
              Consumer
            </b-nav-item>
            <b-nav-item :to="{ name: 'ForVendors' }">
              Vendor
            </b-nav-item>
            <b-nav-item :to="{ name: 'Home', hash: '#feature' }">
              Features
            </b-nav-item>
            <b-nav-item :to="{ name: 'Home', hash: '#contact' }">
              Contact Us
            </b-nav-item>
            <b-nav-item :to="{ name: 'Signin' }">
              Sign In
            </b-nav-item>
            <!-- Phone Number Nav Item for Desktop -->
            <b-nav-item
              href="tel:6042456680"
              class="nav-phone d-none d-lg-block"
              aria-label="Call us at 604-245-6680"
            >
              📞 604-245-6680
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
};
</script>

<style scoped>
.navHome {
  color: #F15B22 !important;
}
.nav-link.active {
  color: #F15B22 !important;
}
.linkSelected.a.nav-link.active {
  color: #F15B22 !important;
}
.navbar-brand img {
  filter: none;
}
/* Styles for Phone Number in Navbar (Desktop) */
.nav-phone {
  color: #28a745 !important; /* Green color for visibility */
  font-weight: bold;
  margin-left: 15px; /* Space it away from other items */
}
.nav-phone:hover {
  text-decoration: none;
  color: #218838 !important; /* Darker green on hover */
}
/* Styles for Mobile Top Bar */
.mobile-top-bar {
  background-color: #f8f9fa; /* Light background */
  z-index: 1030; /* Ensure it sits above other elements */
}
.mobile-phone {
  color: #28a745; /* Match the navbar phone color */
  font-weight: bold;
  text-decoration: none;
  font-size: 1.1em;
}
.mobile-phone:hover {
  color: #218838;
  text-decoration: none;
}
/* Adjust navbar top position when on mobile */
@media (max-width: 991.98px) {
  .navbar.fixed-top {
    top: 50px; /* Adjust based on the height of the mobile top bar */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue